<template>
  <card v-if="isArraySafe && visibility">
    <template v-if="fieldType === 'String' || fieldType === 'Number'">
      <div
        class="wrap"
        v-if="
          fieldName !== 'Description' &&
          fieldName !== 'FromDate' &&
          fieldName !== 'ToDate'
        "
      >
        <b-form-group>
          <label :for="id" class="head"
            >{{ displayName }}
            <span class="validate-error">{{
              isRequired ? "*" : ""
            }}</span></label
          >

          <ValidationProvider
            :rules="isRequired ? 'required' : ''"
            v-slot="{ errors }"
            name="Type"
          >
            <b-form-input
              :type="fieldType === 'String' ? 'text' : 'number'"
              :id="fieldName"
              :value="value"
              v-model="currField"
              @change="onChangeLocal"
              :placeholder="`Enter ${displayName}`"
            ></b-form-input>
            <span class="validate-error">{{
              errors[0]
            }}</span></ValidationProvider
          >
        </b-form-group>
      </div>
      <div
        class="wrap"
        v-if="
          fieldName !== 'Description' &&
          fieldName !== 'ToDate' &&
          fieldName == 'FromDate'
        "
      >
        <label class="head" :for="id"
          >{{ displayName }} {{ isRequired ? "*" : "" }}</label
        >
        <b-input
          :id="id"
          type="date"
          v-model="dateData"
          @input="onChangeLocal"
        ></b-input>
      </div>
      <div
        class="wrap"
        v-if="
          fieldName !== 'Description' &&
          fieldName === 'ToDate' &&
          fieldName !== 'FromDate'
        "
      >
        <label class="head" :for="id"
          >{{ displayName }} {{ isRequired ? "*" : "" }}</label
        >
        <b-input
          :id="id"
          type="date"
          v-model="dateData"
          @input="onChangeLocal"
        ></b-input>
      </div>
      <div
        class="wrap"
        v-if="
          fieldName === 'Description' &&
          fieldName !== 'FromDate' &&
          fieldName !== 'ToDate'
        "
      >
        <b-form-group>
          <label class="head" :for="id"
            >{{ displayName }}
            <span class="validate-error">{{
              isRequired ? "*" : ""
            }}</span></label
          >

          <b-form-textarea
            :id="id"
            class="product-textarea"
            debounce="1000"
            v-model="textareavalue"
            :placeholder="`Enter ${displayName}`"
            @input="onChangeLocal"
            rows="4"
            no-resize
          ></b-form-textarea>
        </b-form-group>
      </div>
    </template>
    <template v-else-if="fieldType === 'Object'">
      <div class="wrap" v-if="fieldName === 'Driver'">
        <strong>Driver {{ isRequired ? "*" : "" }}</strong>
        <ValidationProvider
          :rules="isRequired ? 'required' : ''"
          v-slot="{ errors }"
          name="Type"
        >
          <eb-select
            type="select"
            v-model="selectedDriver"
            :options="userList"
            label="userName"
            id="userNames"
            placeholder="Select Driver"
            :selected="selectedDriver"
            @input="onChangeLocal"
          ></eb-select>
          <span class="validate-error">{{
            errors[0]
          }}</span></ValidationProvider
        >
      </div>
      <div class="wrap" v-if="fieldName === 'agent'">
        <strong
          >Agent
          <span class="validate-error">{{
            isRequired ? "*" : ""
          }}</span></strong
        >
        <ValidationProvider
          :rules="isRequired ? 'required' : ''"
          v-slot="{ errors }"
          name="Type"
        >
          <eb-select
            type="select"
            placeholder="Select Agent"
            label="fullName"
            id="_id"
            v-model="selectedAgent"
            :options="agentList"
            @input="onChangeLocal"
          >
          </eb-select>
          <span class="validate-error">{{
            errors[0]
          }}</span></ValidationProvider
        >
      </div>
      <div class="wrap" v-if="fieldName !== 'Driver' && fieldName !== 'agent'">
        <b-button
          v-b-toggle="`'${fieldName}-id'`"
          variant="outline-primary"
          class="col-12 mb-2"
          @click="setActive(index)"
          >{{ displayName }}</b-button
        >
        <b-collapse
          :id="`${fieldName}-id`"
          class="mt-0"
          :visible="active == index"
        >
          <b-card>
            <div v-for="item in subFields" :key="item._id">
              <field
                :id="item._id"
                :value="value[item.attributeName]"
                :fieldName="item.attributeName"
                :fieldType="item.attributeValueType"
                :level="level + 1"
                :meta="
                  meta.concat([
                    {
                      name: item.attributeName,
                      type: item.attributeValueType,
                    },
                  ])
                "
                :onChange="onChange"
                :UIConcern="item.UIConcern"
                :valuesMap="valuesMap"
              />
            </div>
          </b-card>
        </b-collapse>
      </div>
    </template>
    <template v-else-if="fieldType === 'Array'">
      <div class="wrap">
        <label class="head">{{ displayName }}</label>
        <array
          :items="subFields"
          :UIConcern="UIConcern"
          @change="arrayChange"
          :meta="meta"
          :valuesMap="valuesMap"
          :fieldName="fieldName"
        />
      </div>
    </template>
    <template v-else-if="fieldType === 'Boolean'">
      <v-switch
        color="indigo"
        :value="true"
        :input-value="value"
        @change="onChangeLocal"
        :label="displayName"
      ></v-switch>
    </template>
  </card>
</template>

<style scoped>
.head {
  font-size: 1em;
  font-weight: 800;
}
.wrap {
  margin: 10px;
}
.product-textarea {
  height: auto !important;
}
</style>

<script>
import ArrayField from "./Array";
import Card from "../Generics/Card.vue";
import ebSelect from "@/components/FormElements/Select.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {
      type: String | Number | Object | Array,
    },
    fieldType: {
      type: String,
      required: true,
      default: "String",
    },
    fieldName: {
      type: String,
      required: true,
    },
    displayName: {
      type: String,
      required: true,
    },
    subFields: {
      type: Array,
    },
    level: {
      type: Number,
      required: true,
    },
    meta: {
      type: Array,
      required: true,
    },
    active: {
      type: Number,
    },
    index: {
      type: Number,
    },
    onChange: {
      type: Function,
      required: true,
    },
    setActive: {
      type: Function,
    },
    UIConcern: {
      type: String,
    },
    arrayChange: {
      type: Function,
    },
    valuesMap: {
      type: Object,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    visibility: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onChangeLocal: function (params) {
      if (this.fieldType === "Boolean" && !params) {
        params = false;
      }
      this.onChange({
        meta: this.$props.meta,
        value: params,
      });
    },

    async getDriverList() {
      this.loading = true;
      await this.$store
        .dispatch("item/fetchDriverList")
        .then((data) => {
          if (data.message) {
            this.$toasted.error(data.message);
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    async getAgentList() {
      this.loading = true;
      await this.$store
        .dispatch("tenant/fetchTenantSubAdminList")
        .then((data) => {
          if (data.message) {
            this.$toasted.error(data.message);
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  computed: {
    errorsMessage() {
      if (this.isRequired && !this.textareavalue)
        return "This field is required";
      return "";
    },
    isArraySafe() {
      const { value, fieldType } = this;
      if (value) {
        this.onChange({
          meta: this.$props.meta,
          value: value,
        });
      }
      return (
        (fieldType === "Array" && value && value[0]) || fieldType !== "Array"
      );
    },
    userList() {
      let data = this.$store.getters["item/GetDriverList"];
      if (data && data.length > 0) {
        let users = [];
        data.map((obj) => {
          users.push({
            _id: obj._id,
            userName: obj.authentication.userName,
            email: obj.authentication.email,
            phone: obj.authentication.phone,
          });
        });
        return users;
      }
    },
    agentList() {
      let data = this.$store.getters["tenant/GetTenantSubAdminList"];
      const users = [];
      if (data && data.length > 0) {
        data.map((obj) => {
          users.push({
            _id: obj._id,
            email: obj.authentication.email,
            phone: obj.authentication.phone,
            fullName: `${obj.name.first} ${obj.name.last}`,
            category: obj.category,
            uom: obj.experience ? obj.experience.uom : "",
            experience: obj.experience ? parseInt(obj.experience.value) : 0,
            gender: obj.gender ? obj.gender : "",
            dob: obj.dob ? obj.dob : "",
            profilePhoto: obj.profilePhoto ? obj.profilePhoto : "",
          });
        });
      }

      return users;
    },
  },
  watch: {
    value(val) {
      this.currField = val;
    },
  },
  async mounted() {
    if (this.fieldType === "Object" && this.fieldName === "Driver") {
      const driverList = await this.$store.getters["item/GetDriverList"];
      if (!driverList || !driverList.length) {
        this.getDriverList();
      }
    }
    if (this.fieldType === "Object" && this.fieldName === "agent") {
      const agentList = await this.$store.getters[
        "tenant/GetTenantSubAdminList"
      ];
      if (!agentList || !agentList.length) {
        this.getAgentList();
      }
    }
  },
  data() {
    return {
      textareavalue: this.value,
      selectedDriver: {},
      selectedAgent: "",
      currField: this.value,
    };
  },
  name: "field",
  components: {
    array: ArrayField,
    card: Card,
    ebSelect,
    ValidationProvider,
    ValidationObserver,
  },
};
</script>
